import { MediaQuery } from '@cae/cobalt-react/enums';
import { useMediaQuery } from '@cae/cobalt-react/hooks';
import { useInvoicesData } from '@features/invoices/contexts/data/useInvoicesData';
import { useInvoicesFilter } from '@features/invoices/contexts/filter/useInvoicesFilter';
import { ContentLoader } from '@shared/components/content-loader/ContentLoader';
import { InlineFeedback } from '@shared/components/inline-feedback/InlineFeedback';
import * as React from 'react';

import { InvoicesTableMobile } from './table-mobile/InvoicesTableMobile';
import { InvoicesTable } from './table/InvoicesTable';

const InvoicesContent = React.memo((): React.ReactElement => {
  const { invoices } = useInvoicesData();
  const { isSearchApplied } = useInvoicesFilter();

  const isMobileAndTablet = useMediaQuery(MediaQuery.MobileAndTablet);

  if (invoices.isLoading) {
    return <ContentLoader />;
  }

  if (invoices.isError) {
    return <InlineFeedback type="data-error" />;
  }

  if (invoices.data.elements.length === 0) {
    if (isSearchApplied) return <InlineFeedback type="no-search-results" />;
    return <InlineFeedback type="so-empty" />;
  }

  return isMobileAndTablet ? <InvoicesTableMobile /> : <InvoicesTable />;
});

InvoicesContent.displayName = 'InvoicesContent';

export { InvoicesContent };
